// import _ from 'lodash'
// import React, { useEffect, useState } from 'react'

// import { useDispatch, useSelector } from 'react-redux'
// import { WidthProvider, Responsive } from 'react-grid-layout'
// import 'react-grid-layout/css/styles.css'
// import 'react-resizable/css/styles.css'

// import { Button, Card, Spinner } from 'reactstrap'

// // core components
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// import { FitToViewport } from 'react-fit-to-viewport'

// import {
// 	fetchUserGroupProgress,
// 	fetchGroupsCourses,
// 	fetchGroups,
// } from 'store/Group/actions'
// import { fetchUserProgress, fetchCourses, progress } from 'store/Course/actions'
// import { fetchUserExternalReports } from 'store/ExternalReports/actions'
// import { getExemptCourses } from 'store/EmployeeReport/actions'

// import {
// 	faArrowsUpDownLeftRight,
// 	faTrash,
// } from '@fortawesome/free-solid-svg-icons'

// import {
// 	setDashboards,
// 	setLayouts,
// 	setToolbox,
// 	setCurrentDashboardId,
// 	setCurrentBreakpoint,
// 	handleToggleItem,
// 	handleCancel,
// } from 'store/Dashboard/actions'
// import { toggleScaledDashboard } from 'store/user/actions'
// import 'suneditor/dist/css/suneditor.min.css'
// import AxiosInstance from 'utils/AxiosInstance'
// import Rewards from '../components/Rewards'
// import Commboard from '../components/Commboard'
// import RestaurantProgress from '../components/RestaurantProgress'
// import PromotedCourse from '../components/PromotedCourse'
// import CoreTrainingProgress from '../components/CoreTrainingProgress'
// import CoursesCompleted from '../components/CoursesCompleted'
// import WhereYouLeftCourse from '../components/WhereYouLeftCourse'
// import ManagersOverview from './ManagersOverview'
// import DashboardProfile from './DashboardProfile'
// import CourseOverview from '../components/CourseOverview'

// import './style.css'

// const ScaledContainer = ({ children }) => {
// 	const [viewportHeight, setViewportHeight] = useState(
// 		window.innerWidth > 1600 ? 1600 : 1200
// 	)

// 	useEffect(() => {
// 		const handleResize = () => {
// 			setViewportHeight(window.innerWidth > 1600 ? 1600 : 1200)
// 		}

// 		window.addEventListener('resize', handleResize)
// 		return () => {
// 			window.removeEventListener('resize', handleResize)
// 		}
// 	}, [])
// 	return (
// 		<FitToViewport
// 			width={1900}
// 			height={viewportHeight}
// 			minZoom={0}
// 			maxZoom={0.6}
// 			style={{
// 				transformOrigin: 'top center',
// 			}}
// 			className='mt-7'
// 		>
// 			{children}
// 		</FitToViewport>
// 	)
// }

// const ResponsiveGridLayout = WidthProvider(Responsive)
// const DragBoard = (props) => {
// 	const { user, sidebarShowing } = useSelector((state) => state.auth)

// 	const { layouts, toolbox, currentBreakpoint } = useSelector(
// 		(state) => state.dashboard
// 	)
// 	const adjustedLayouts = props.scaled ? { lg: layouts.lg } : layouts

// 	const Container = props.scaled ? ScaledContainer : 'div'
// 	const courses = useSelector((state) => state.courses)
// 	const groups = useSelector((state) => state.groups)
// 	const language = useSelector((state) => state.language.language?.data)
// 	const externalReports = useSelector((state) => state.externalReports)
// 	const employeeReport = useSelector((state) => state.employeeReport)

// 	const [completedCourses, setCompletedCourses] = useState(0)
// 	const [loading, setLoading] = useState(false)

// 	let completed
// 	let pending
// 	let noActivity

// 	const [managersOverview, setManagersOverview] = useState([])
// 	const [managersLoading, setManagersLoading] = useState(false)

// 	const dispatch = useDispatch()

// 	useEffect(() => {
// 		if (!Object.entries(layouts).length) {
// 			fetchLayout()
// 		}
// 		dispatch(fetchCourses())
// 		fetchUsers()
// 		fetchUsersByStores()
// 		getCompletedCourses()
// 		dispatch(fetchGroups())
// 		dispatch(fetchGroupsCourses())
// 		dispatch(progress())
// 		dispatch(fetchCourses())
// 		dispatch(fetchUserGroupProgress())
// 		dispatch(fetchUserProgress())
// 		dispatch(fetchUserExternalReports())
// 		dispatch(getExemptCourses())
// 		return () => {
// 			dispatch(handleCancel())
// 			dispatch(toggleScaledDashboard(false))
// 		}
// 	}, [])

// 	const fetchLayout = () => {
// 		const position =
// 			user.access === 1 ? 0 : [2, 4, 5].includes(user.access) ? 1 : 2
// 		AxiosInstance.get('/users/layout')
// 			.then((response) => {
// 				dispatch(setDashboards(response))
// 				dispatch(setLayouts(JSON.parse(response[position].data)))
// 				dispatch(setToolbox(JSON.parse(response[position].toolbox)))
// 				dispatch(setCurrentDashboardId(JSON.parse(response[position].id)))
// 			})
// 			.catch((error) => {
// 				console.error('Error retrieving layout:', error)
// 			})
// 	}

// 	const fetchUsers = () => {
// 		AxiosInstance.get('/users').then((data) => {
// 			if (Array.isArray(data)) {
// 				data = data.map((item) => {
// 					return {
// 						...item,
// 						avatar:
// 							typeof item.avatar === 'string' ? JSON.parse(item.avatar) : null,
// 					}
// 				})
// 			}
// 		})
// 	}

// 	const fetchUsersByStores = () => {
// 		if (!managersOverview.length) {
// 			setManagersLoading(true)
// 			AxiosInstance.get('/users/store-users').then((data) => {
// 				setManagersOverview(data)
// 				setManagersLoading(false)
// 			})
// 		}
// 	}

// 	const getCompletedCourses = async () => {
// 		try {
// 			const completed = await AxiosInstance.get('/users/self/progress').then(
// 				(completedCourse) =>
// 					completedCourse.filter((course) => course.status === 4)
// 			)
// 			const noDuplicateCompletedCourses = completed.filter(
// 				(item, index) =>
// 					index ===
// 					completed.findIndex((elem) => elem.course_id === item.course_id)
// 			)
// 			if (noDuplicateCompletedCourses) {
// 				setCompletedCourses(noDuplicateCompletedCourses.length)
// 			}
// 			setLoading(false)
// 		} catch (e) {
// 			console.log(e, 'error')
// 		}
// 	}
// 	const percentage =
// 		completedCourses && courses.courses.length > 0
// 			? (completedCourses / courses.courses.length) * 100
// 			: '0'

// 	let stroke =
// 		courses.courses.length - completedCourses === 0
// 			? 141.392
// 			: (141.392 * (courses.courses.length - completedCourses)) /
// 			  courses.courses.length

// 	const onBreakpointChange = (breakpoint) => {
// 		dispatch(setCurrentBreakpoint(breakpoint))
// 	}

// 	const onLayoutChange = (layout, layouts) => {
// 		dispatch(setLayouts(layouts))
// 	}

// 	useEffect(() => {
// 		setTimeout(() => {
// 			window.dispatchEvent(new Event('resize'))
// 		}, 200)
// 	}, [sidebarShowing])

// 	const generateDOM = () => {
// 		return _.map(layouts[currentBreakpoint], (l) => {
// 			const box = toolbox?.find((element) => element.id == l.i)

// 			return (
// 				<div key={l.i} className={`${l.static ? 'static' : ''}`}>
// 					{props.scaled && (
// 						<div className='overlay'>
// 							<div className='d-flex h-100 justify-content-center align-items-center'>
// 								<div
// 									className={`drag-handle py-2 px-3  ${
// 										props.scaled && 'react-grid-drag-cursor'
// 									}`}
// 								>
// 									<FontAwesomeIcon
// 										icon={faArrowsUpDownLeftRight}
// 										className='text-darker'
// 									/>
// 								</div>
// 								<div
// 									className='delete-bttn py-2 px-3'
// 									onClick={() => dispatch(handleToggleItem(box))}
// 								>
// 									<FontAwesomeIcon icon={faTrash} className='text-white' />
// 								</div>
// 							</div>
// 						</div>
// 					)}

// 					{(() => {
// 						switch (l.i) {
// 							case 'profile':
// 								return <DashboardProfile user={user} />

// 							case 'courses-completed':
// 								return (
// 									<div key='courses-completed'>
// 										<CoursesCompleted
// 											courses={courses}
// 											completedCourses={completedCourses}
// 											loading={loading}
// 											percentage={percentage}
// 											stroke={stroke}
// 										/>
// 										<WhereYouLeftCourse />
// 									</div>
// 								)
// 							case 'commboard':
// 								return <Commboard />
// 							case 'managers-overview':
// 								return (
// 									<ManagersOverview
// 										managersLoading={managersLoading}
// 										managersOverview={managersOverview}
// 										completed={completed}
// 										pending={pending}
// 										noActivity={noActivity}
// 									/>
// 								)
// 							case 'promoted-course':
// 								return <PromotedCourse />
// 							case 'restaurant-progress':
// 								return <RestaurantProgress />
// 							case 'rewards':
// 								return <Rewards />
// 							case 'training-1':
// 								return (
// 									<Card className='h-100'>
// 										<CoreTrainingProgress
// 											groups={groups}
// 											language={language}
// 											tag='1'
// 											courses={courses}
// 											{...externalReports}
// 											employee={employeeReport}
// 											name={
// 												language?.general
// 													? language.general.core_training
// 													: null
// 											}
// 										/>
// 									</Card>
// 								)
// 							case 'training-2':
// 								return (
// 									<Card className='h-100'>
// 										<CoreTrainingProgress
// 											groups={groups}
// 											language={language}
// 											tag='2'
// 											courses={courses}
// 											{...externalReports}
// 											employee={employeeReport}
// 											name={
// 												language?.general
// 													? language.general.initiative_training
// 													: null
// 											}
// 										/>
// 									</Card>
// 								)
// 							case 'course-overview':
// 								return <CourseOverview />
// 							default:
// 								return null
// 						}
// 					})()}
// 				</div>
// 			)
// 		})
// 	}

// 	return (
// 		<div className={`${props.scaled ? 'main-content h-100 mt--6' : ''}`}>
// 			<div className={`${props.scaled ? 'd-flex justify-content-center' : ''}`}>
// 				<div>
// 					{Object.keys(layouts).length > 0 ? (
// 						<>
// 							<div
// 								className={`${props.scaled ? 'mt--8' : 'mt--7'}`}
// 								fluid
// 							></div>

// 							<Container>
// 								<ResponsiveGridLayout
// 									className='layout mt--6 px-0'
// 									layouts={adjustedLayouts}
// 									key={sidebarShowing}
// 									rowHeight={50}
// 									breakpoints={
// 										props.scaled
// 											? { lg: 992 }
// 											: { lg: 1200, md: 996, sm: 768, xs: 480 }
// 									}
// 									cols={
// 										props.scaled
// 											? { lg: 6, md: 6 }
// 											: { lg: 6, md: 4, sm: 4, xs: 1, xxs: 1 }
// 									}
// 									onBreakpointChange={onBreakpointChange}
// 									onLayoutChange={onLayoutChange}
// 									margin={[25, 25]}
// 									isDroppable={true}
// 									useCSSTransforms={true}
// 									draggableHandle='.react-grid-drag-cursor'
// 									isBounded={true}
// 									isDraggable={props.scaled}
// 									isResizable={props.scaled}
// 									transformScale={props.scaled && 0.6}
// 								>
// 									{generateDOM()}
// 								</ResponsiveGridLayout>
// 							</Container>
// 						</>
// 					) : (
// 						<div className='mt-7 text-center'>
// 							<Spinner
// 								color='primary'
// 								style={{ height: '4rem', width: '4rem' }}
// 							/>
// 						</div>
// 					)}
// 				</div>
// 			</div>
// 		</div>
// 	)
// }

// export default DragBoard

import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { WidthProvider, Responsive } from 'react-grid-layout'
import { Card } from 'reactstrap'
// core components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FitToViewport } from 'react-fit-to-viewport'
import {
  faArrowsUpDownLeftRight,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'

import {
  fetchUserGroupProgress,
  fetchGroupsCourses,
  fetchGroups,
} from 'store/Group/actions'
import { fetchUserProgress, fetchCourses, progress } from 'store/Course/actions'
import { fetchUserExternalReports } from 'store/ExternalReports/actions'
import { getExemptCourses } from 'store/EmployeeReport/actions'
import {
  setDashboards,
  setLayouts,
  setToolbox,
  setCurrentDashboardId,
  setCurrentBreakpoint,
  handleToggleItem,
  handleCancel,
} from 'store/Dashboard/actions'
import { toggleScaledDashboard } from 'store/user/actions'
import 'suneditor/dist/css/suneditor.min.css'
import AxiosInstance from 'utils/AxiosInstance'
import Rewards from '../components/Rewards'
import Commboard from '../components/Commboard'
import RestaurantProgress from '../components/RestaurantProgress'
import PromotedCourse from '../components/PromotedCourse'
import ManagerAlert from '../components/ManagerAlert'
import CoreTrainingProgress from '../components/CoreTrainingProgress'
import CoursesCompleted from '../components/CoursesCompleted'
import WhereYouLeftCourse from '../components/WhereYouLeftCourse'
import ManagersOverview from './ManagersOverview'
import DashboardProfile from './DashboardProfile'
import CourseOverview from '../components/CourseOverview'
import { setEditBreakpoint } from 'store/Dashboard/actions'
import Discussion from 'views/pages/Discussion/components'
import Loader from 'views/pages/Loader'

import './style.css'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import { setWhereYouLeftFetched } from 'store/Dashboard/actions'
import { setCompletedCoursesFetched } from 'store/Dashboard/actions'
import { setMessagesFetched } from 'store/Dashboard/actions'
import { setManagersOverviewFetched } from 'store/Dashboard/actions'
import { setRewardsFetched } from 'store/Dashboard/actions'
import { setRestaurantProgressFetched } from 'store/Dashboard/actions'
import { setCoursesOverviewFetched } from 'store/Dashboard/actions'
import { fetchUsers } from 'store/Users/actions'
import { fetchUsersGroupManagerApproval } from 'store/Users/actions'
import { fetchUsersManagerApproval } from 'store/Users/actions'
import { setManagerApprovalFetched } from 'store/Dashboard/actions'
import { setRestaurantProgress } from 'store/Dashboard/actions'
import { setSkipLocations } from 'store/Dashboard/actions'
import { SET_USERS } from 'store/Users/constants'
import { setPromotedCoursesFetched } from 'store/Dashboard/actions'
import { fetchStores } from 'store/Stores/actions'

const ScaledContainer = ({ children }) => {
  const [viewportHeight, setViewportHeight] = useState(
    window.innerWidth > 1600 ? 1600 : 1200
  )
  const { editBreakpoint } = useSelector((state) => state.dashboard)
  const dispatch = useDispatch()

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerWidth > 1600 ? 1600 : 1200)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      dispatch(setEditBreakpoint('lg'))
    }
  }, [])

  return (
    <FitToViewport
      width={
        editBreakpoint === 'lg' ? 1900 : editBreakpoint === 'md' ? 1000 : 650
      }
      height={viewportHeight}
      minZoom={0}
      maxZoom={0.6}
      style={{
        transformOrigin: 'top center',
      }}
      className='mt-5'
    >
      {children}
    </FitToViewport>
  )
}

const ResponsiveGridLayout = WidthProvider(Responsive)
function DragBoard(props) {
  const { user, sidebarShowing } = useSelector((state) => state.auth)

  const { layouts, toolbox, currentBreakpoint, editBreakpoint } = useSelector(
    (state) => state.dashboard
  )

  const adjustedLayouts = props.scaled
    ? { lg: layouts?.lg, md: layouts?.md, sm: layouts?.sm }
    : layouts

  const Container = props.scaled ? ScaledContainer : 'div'
  const courses = useSelector((state) => state.courses)
  const groups = useSelector((state) => state.groups)
  const language = useSelector((state) => state.language.language?.data)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!Object.entries(layouts || {}).length) {
      fetchLayout()
    }
    dispatch(fetchCourses(true))
    fetchUserss()
    // fetchUsersByStores()
    // getCompletedCourses()
    // dispatch(fetchGroups())
    dispatch(fetchGroupsCourses())
    dispatch(fetchStores())
    // dispatch(progress())
    dispatch(fetchUserProgress())

    dispatch(fetchUserGroupProgress())
    dispatch(setWhereYouLeftFetched(false))
    dispatch(setCompletedCoursesFetched(false))
    dispatch(setMessagesFetched(false))
    dispatch(setManagersOverviewFetched(false))
    dispatch(setRewardsFetched(false))
    dispatch(setPromotedCoursesFetched(false))
    dispatch(
      setRestaurantProgress({
        locationFilter: '',
      })
    )

    dispatch(setSkipLocations(0))
    dispatch(setRestaurantProgress({ locations: [] }))
    dispatch(setRestaurantProgressFetched(false))
    dispatch(setCoursesOverviewFetched(false))
    dispatch(setManagerApprovalFetched(false))
    // dispatch(fetchUserProgress())
    // dispatch(fetchUserExternalReports())
    // dispatch(getExemptCourses())

    return () => {
      // React 18 fix: ensure cleanup functions don't dispatch async actions
      try {
        dispatch(handleCancel())
        dispatch(toggleScaledDashboard(false))
      } catch (error) {
        console.warn('Cleanup error:', error)
      }
    }
  }, [])

  const fetchLayout = () => {
    const position =
      user.access === 1 ? 0 : [2, 4, 5].includes(user.access) ? 1 : 2
    AxiosInstance.get('/users/layout')
      .then((response) => {
        // console.log(response, 'responseee')

        const responseModified = response.map((resp) => {
          return {
            ...resp,
            data: JSON.parse(resp.data),
            toolbox: JSON.parse(resp.toolbox),
          }
        })

        // console.log(responseModified, 'responseModified')
        dispatch(setDashboards(responseModified))
        dispatch(setLayouts(responseModified[position].data))
        dispatch(setToolbox(responseModified[position].toolbox))
        dispatch(setCurrentDashboardId(responseModified[position].id))
      })
      .catch((error) => {
        console.error('Error retrieving layout:', error)
      })
  }

  const containsCoreOrInitiativeWidget = layouts[currentBreakpoint]
    ?.map((layout) => layout?.i)
    ?.some((i) => i === 'training-1' || i === 'training-2')

  useEffect(() => {
    if (containsCoreOrInitiativeWidget) {
      dispatch(getExemptCourses(user.id))
      dispatch(fetchUserExternalReports(user.id))
    }
  }, [containsCoreOrInitiativeWidget, dispatch, user.id])

  const fetchUserss = () => {
    AxiosInstance.get('/users').then((data) => {
      if (Array.isArray(data)) {
        data = data.map((item) => {
          return {
            ...item,
            avatar:
              typeof item.avatar === 'string' ? JSON.parse(item.avatar) : null,
          }
        })
      }

      dispatch({ type: SET_USERS, data })
    })
  }

  const onBreakpointChange = (breakpoint) => {
    const finalBreakpoint = breakpoint === 'xs' ? 'sm' : breakpoint
    dispatch(setCurrentBreakpoint(finalBreakpoint))
  }

  const onLayoutChange = (layout, layouts) => {
    dispatch(setLayouts(layouts))
  }

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 100)
  }, [sidebarShowing, editBreakpoint, props.scaled])

  const generateDOM = () => {
    return _.map(layouts[currentBreakpoint], (l) => {
      const box = toolbox?.find((element) => element.id === l.i)

      return (
        <div key={l.i} className={`${l.static ? 'static' : ''}`}>
          {props.scaled && (
            <div className='overlay'>
              <div className='d-flex h-100 justify-content-center align-items-center'>
                <div
                  className={`drag-handle py-2 px-3  ${
                    props.scaled && 'react-grid-drag-cursor'
                  }`}
                >
                  <FontAwesomeIcon
                    icon={faArrowsUpDownLeftRight}
                    className='text-darker'
                  />
                </div>
                <div
                  className='delete-bttn py-2 px-3'
                  onClick={() => dispatch(handleToggleItem(box))}
                >
                  <FontAwesomeIcon icon={faTrash} className='text-white' />
                </div>
              </div>
            </div>
          )}

          {(() => {
            switch (l.i) {
              case 'profile':
                return <DashboardProfile user={user} />

              case 'courses-completed':
                return (
                  <div key='courses-completed' className='h-100'>
                    <CoursesCompleted />
                    <WhereYouLeftCourse />
                  </div>
                )
              case 'commboard':
                return <Commboard />
              case 'managers-overview':
                return <ManagersOverview />
              case 'promoted-course':
                return <PromotedCourse />
              case 'restaurant-progress':
                return <RestaurantProgress />
              case 'discussions':
                return <Discussion />
              case 'rewards':
                return <Rewards />
              case 'manager-alert':
                return <ManagerAlert />
              case 'training-1':
                return (
                  <Card className='h-100'>
                    <CoreTrainingProgress
                      groups={groups}
                      language={language}
                      tag='1'
                      courses={courses}
                      name={
                        language?.general
                          ? language.general.core_training
                          : null
                      }
                    />
                  </Card>
                )
              case 'training-2':
                return (
                  <Card className='h-100'>
                    <CoreTrainingProgress
                      groups={groups}
                      language={language}
                      tag='2'
                      courses={courses}
                      name={
                        language?.general
                          ? language.general.initiative_training
                          : null
                      }
                    />
                  </Card>
                )
              case 'course-overview':
                return <CourseOverview />
              default:
                return null
            }
          })()}
        </div>
      )
    })
  }

  return (
    <div className={`${props.scaled ? 'main-content h-100 mt--6' : ''}`}>
      <div className={`${props.scaled ? 'd-flex justify-content-center' : ''}`}>
        <div
          className={`${props.scaled && 'horizontal-scroll'} grid-container `}
        >
          <div className={``}>
            {Object?.keys(layouts || {})?.length > 0 && (
              <>
                <div
                  className={`${props.scaled ? 'mt--8' : 'dashboard-header'}`}
                  fluid
                  // style={{ marginTop: props.scaled ? '-8rem' : '-11rem' }}
                ></div>

                <Container className='mb-5'>
                  <ResponsiveGridLayout
                    className='layout mt--6 px-0'
                    layouts={adjustedLayouts}
                    key={sidebarShowing}
                    rowHeight={50}
                    breakpoints={
                      props.scaled
                        ? { lg: 1000, md: 800, sm: 600 }
                        : { lg: 1000, md: 800, sm: 600, xs: 480 }
                    }
                    cols={
                      props.scaled
                        ? { lg: 6, md: 6, sm: 3 }
                        : { lg: 6, md: 6, sm: 3, xs: 1, xxs: 1 }
                    }
                    onBreakpointChange={onBreakpointChange}
                    onLayoutChange={onLayoutChange}
                    margin={[25, 25]}
                    isDroppable={true}
                    useCSSTransforms={true}
                    draggableHandle='.react-grid-drag-cursor'
                    isBounded={false}
                    isDraggable={props.scaled}
                    isResizable={props.scaled}
                    transformScale={props.scaled && 0.6}
                  >
                    {generateDOM()}
                  </ResponsiveGridLayout>
                </Container>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default DragBoard
